import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { FeedbackFish } from '@feedback-fish/react';
import { useSelector } from 'react-redux';
import type { RootReducerType } from '../../../redux/reducers/RootReducer.types';

const FeedbackButton = () => {
  const [isFeedbackEnabled, setIsFeedbackEnabled] = useState<boolean>(false);
  const { cookiePreferences } = useSelector(
    (state: RootReducerType) => state.storage,
  );
  const { t } = useTranslation();
  // const feebackProjectId = '72f94fcac65863'; // TODO: read from config

  useEffect(() => {
    if (cookiePreferences?.preferences.feedbackfish) {
      if (isFeedbackEnabled !== cookiePreferences.preferences.feedbackfish) {
        setIsFeedbackEnabled(cookiePreferences.preferences.feedbackfish);
      }
    }
  }, [cookiePreferences]);

  const leaveFeedbackClick = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.open(
        'https://discordapp.com/channels/1194693419923157142/1194693419923157145',
        '_blank',
      );
    }
  }, []);

  return isFeedbackEnabled ? (
    // <FeedbackFish projectId={feebackProjectId}>
    <button
      type="button"
      data-test-id="dashboard-side-menu-item-feedback"
      data-umami-event="dashboard-side-menu-item-feedback"
      className="cursor-pointer rounded-lg border border-sky-600 bg-sky-600 px-3 py-1 text-sm font-bold text-white shadow-sm hover:bg-white hover:text-sky-600"
      onClick={leaveFeedbackClick}
    >
      {t('static.dashboard.side_menu_item_label_feedback')}
    </button>
  ) : // </FeedbackFish>
  null;
};

export default FeedbackButton;
